import React from 'react';
import PropTypes from 'prop-types';

const Spinner = ({ size = 'md', color = 'blue' }) => {
  // Size classes
  const sizeClasses = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-5 w-5',
    xl: 'h-6 w-6'
  };

  // Color classes
  const colorClasses = {
    blue: 'border-blue-600',
    gray: 'border-gray-600',
    white: 'border-white'
  };

  return (
    <div 
      className={`
        animate-spin rounded-full 
        ${sizeClasses[size]} 
        border-2 
        border-gray-200 
        ${colorClasses[color]}
        border-t-transparent
      `}
    />
  );
};

Spinner.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  color: PropTypes.oneOf(['blue', 'gray', 'white'])
};

export default Spinner; 